exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog[data-v-09a2488e]{height:100%;padding:0!important;margin:0!important;max-width:100%!important}.modal-content[data-v-09a2488e]{height:100%;border-radius:inherit;border:0}.close[data-v-09a2488e]{font-size:2.8rem;font-weight:100;color:#fff;text-shadow:none;opacity:1}.zp-modal-head[data-v-09a2488e]{background-color:#3a4339;text-align:center;padding-top:5rem;padding-bottom:1rem;color:#fff}", ""]);

// exports
